var map = {
	"./account/routes.js": 67405,
	"./authentication/routes.js": 33683,
	"./dashboard/routes.js": 12002,
	"./device/routes.js": 31493,
	"./message-center/routes.js": 78664,
	"./shell/routes.js": 63736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99390;